import imgSrc from '@images/marketing/PDPs/Meals-NomTips.jpg';
export var storeServePrepSectionContent = {
    faqs: [
        {
            question: 'How to Store',
            answer: 'Our food is packed with dry ice (careful of hands and paws) so it arrives either frozen or cold to the touch. Store in the freezer immediately after unboxing for up to 6 months.',
        },
        {
            question: 'How to Prep',
            answer: 'When ready to use, thaw meal packs in the fridge overnight. Once defrosted, food can be kept in the fridge for up to 5 days.',
        },
        {
            question: 'How to Serve',
            answer: 'Simply pour and serve, according to your pup’s personalized feeding instructions. You can also run sealed meal packs under warm waters to release those yummy aromas!',
        },
    ],
    imageData: {
        src: imgSrc,
        alt: 'A dog peeks into the fridge as its owner pulls out a package of Nom Nom',
    },
};
